const firebaseAuthErrorMessages: Record<string, string> = {
  "auth/admin-restricted-operation": "Operation restricted to administrators only.",
  "auth/argument-error": "An invalid argument was provided.",
  "auth/app-not-authorized": "This app is not authorized to use Firebase Authentication.",
  "auth/app-not-installed": "The required app is not installed.",
  "auth/captcha-check-failed": "Captcha verification failed.",
  "auth/code-expired": "The verification code has expired.",
  "auth/cordova-not-ready": "Cordova framework is not ready.",
  "auth/cors-unsupported": "Cross-origin resource sharing is unsupported.",
  "auth/credential-already-in-use": "This credential is already in use.",
  "auth/custom-token-mismatch": "The custom token does not match the expected format.",
  "auth/requires-recent-login": "You need to log in again.",
  "auth/dependent-sdk-initialized-before-auth": "A dependent SDK was initialized before Firebase Auth.",
  "auth/dynamic-link-not-activated": "Dynamic links are not activated for this project.",
  "auth/email-change-needs-verification": "Email change requires verification.",
  "auth/email-already-in-use": "This email is already in use.",
  "auth/emulator-config-failed": "Failed to configure the emulator.",
  "auth/expired-action-code": "The action code has expired.",
  "auth/cancelled-popup-request": "The popup request was cancelled.",
  "auth/internal-error": "An internal error occurred.",
  "auth/invalid-api-key": "The provided API key is invalid.",
  "auth/invalid-app-credential": "The app credential is invalid.",
  "auth/invalid-app-id": "The app ID is invalid.",
  "auth/invalid-user-token": "The user token is invalid.",
  "auth/invalid-auth-event": "The authentication event is invalid.",
  "auth/invalid-cert-hash": "The certificate hash is invalid.",
  "auth/invalid-verification-code": "The verification code is invalid.",
  "auth/invalid-continue-uri": "The continue URL is invalid.",
  "auth/invalid-cordova-configuration": "The Cordova configuration is invalid.",
  "auth/invalid-custom-token": "The custom token is invalid.",
  "auth/invalid-dynamic-link-domain": "The dynamic link domain is invalid.",
  "auth/invalid-email": "The email address is invalid.",
  "auth/invalid-emulator-scheme": "The emulator scheme is invalid.",
  "auth/invalid-credential": "The credential is invalid.",
  "auth/invalid-message-payload": "The message payload is invalid.",
  "auth/invalid-multi-factor-session": "The multi-factor session is invalid.",
  "auth/invalid-oauth-client-id": "The OAuth client ID is invalid.",
  "auth/invalid-oauth-provider": "The OAuth provider is invalid.",
  "auth/invalid-action-code": "The action code is invalid.",
  "auth/unauthorized-domain": "The domain is unauthorized.",
  "auth/wrong-password": "The password is incorrect.",
  "auth/invalid-persistence-type": "The persistence type is invalid.",
  "auth/invalid-phone-number": "The phone number is invalid.",
  "auth/invalid-provider-id": "The provider ID is invalid.",
  "auth/invalid-recipient-email": "The recipient email is invalid.",
  "auth/invalid-sender": "The sender is invalid.",
  "auth/invalid-verification-id": "The verification ID is invalid.",
  "auth/invalid-tenant-id": "The tenant ID is invalid.",
  "auth/multi-factor-info-not-found": "Multi-factor info not found.",
  "auth/multi-factor-auth-required": "Multi-factor authentication is required.",
  "auth/missing-android-pkg-name": "The Android package name is missing.",
  "auth/missing-app-credential": "The app credential is missing.",
  "auth/auth-domain-config-required": "The auth domain configuration is required.",
  "auth/missing-verification-code": "The verification code is missing.",
  "auth/missing-continue-uri": "The continue URL is missing.",
  "auth/missing-iframe-start": "The iframe start is missing.",
  "auth/missing-ios-bundle-id": "The iOS bundle ID is missing.",
  "auth/missing-or-invalid-nonce": "The nonce is missing or invalid.",
  "auth/missing-multi-factor-info": "The multi-factor info is missing.",
  "auth/missing-multi-factor-session": "The multi-factor session is missing.",
  "auth/missing-phone-number": "The phone number is missing.",
  "auth/missing-verification-id": "The verification ID is missing.",
  "auth/app-deleted": "The app has been deleted.",
  "auth/account-exists-with-different-credential": "An account exists with a different credential.",
  "auth/network-request-failed": "The network request failed.",
  "auth/null-user": "No user is signed in.",
  "auth/no-auth-event": "No authentication event was found.",
  "auth/no-such-provider": "No such provider exists.",
  "auth/operation-not-allowed": "The operation is not allowed.",
  "auth/operation-not-supported-in-this-environment": "The operation is not supported in this environment.",
  "auth/popup-blocked": "The popup was blocked.",
  "auth/popup-closed-by-user": "The popup was closed by the user.",
  "auth/provider-already-linked": "The provider is already linked to this account.",
  "auth/quota-exceeded": "The quota has been exceeded.",
  "auth/redirect-cancelled-by-user": "The redirect was cancelled by the user.",
  "auth/redirect-operation-pending": "A redirect operation is pending.",
  "auth/rejected-credential": "The credential was rejected.",
  "auth/second-factor-already-in-use": "The second factor is already in use.",
  "auth/maximum-second-factor-count-exceeded": "The maximum number of second factors has been exceeded.",
  "auth/tenant-id-mismatch": "The tenant ID does not match.",
  "auth/timeout": "The operation timed out.",
  "auth/user-token-expired": "The user token has expired.",
  "auth/too-many-requests": "Too many attempts, please try again later.",
  "auth/unauthorized-continue-uri": "The continue URI is unauthorized.",
  "auth/unsupported-first-factor": "The first factor is unsupported.",
  "auth/unsupported-persistence-type": "The persistence type is unsupported.",
  "auth/unsupported-tenant-operation": "The tenant operation is unsupported.",
  "auth/unverified-email": "The email address is unverified.",
  "auth/user-cancelled": "The user cancelled the operation.",
  "auth/user-not-found": "No user found with this identifier.",
  "auth/user-disabled": "The user account has been disabled.",
  "auth/user-mismatch": "The user does not match.",
  "auth/user-signed-out": "The user has signed out.",
  "auth/weak-password": "The password is too weak.",
  "auth/web-storage-unsupported": "Web storage is unsupported.",
  "auth/already-initialized": "Firebase Auth has already been initialized.",
  "auth/recaptcha-not-enabled": "reCAPTCHA is not enabled.",
  "auth/missing-recaptcha-token": "The reCAPTCHA token is missing.",
  "auth/invalid-recaptcha-token": "The reCAPTCHA token is invalid.",
  "auth/invalid-recaptcha-action": "The reCAPTCHA action is invalid.",
  "auth/missing-client-type": "The client type is missing.",
  "auth/missing-recaptcha-version": "The reCAPTCHA version is missing.",
  "auth/invalid-recaptcha-version": "The reCAPTCHA version is invalid.",
  "auth/invalid-req-type": "The request type is invalid."
};

export default firebaseAuthErrorMessages;
